var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","height":"100%"}},[_c('el-button',{staticStyle:{"position":"fixed"},attrs:{"size":"mini","type":"warning"},on:{"click":function($event){return _vm.back()}}},[_vm._v("退出")]),_vm._v(" "),_c('iframe',{staticStyle:{"height":"100%","width":"100%"},attrs:{"src":"https://school.mibee.cn/"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d08db62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/School/Index.vue
// module id = null
// module chunks = 